import Button from '@components/Button'
import { isExternalUrl } from 'shared/utils'

import BuyButton from './BuyButton'
import styles from './styles.module.scss'

const BuyButtonCTA = ({ opngo, externalSeasonTicketUrl, buyLabel, bookingUrl, canBuy }) =>
    opngo || !!externalSeasonTicketUrl ? (
        <BuyButton opngo={opngo} externalSeasonTicketUrl={externalSeasonTicketUrl} buyLabel={buyLabel} />
    ) : canBuy ? (
        <Button href={bookingUrl} block external={isExternalUrl(bookingUrl)}>
            <T>{buyLabel}</T>
        </Button>
    ) : (
        <div className={styles.unbookable}>
            <T>map.results.list.book.na</T>
        </div>
    )

export default BuyButtonCTA
